import React from 'react';
import TextComponent from '@/components/TextComponent';
import styled from 'styled-components';
import SelectComponent from '@/components/SelectComponent';
import { hours, minutes } from '@/assets/data/selectOptions';
import { ReactComponent as Checked } from '@/assets/images/order/checked.svg';
import { ReactComponent as UnChecked } from '@/assets/images/order/unchecked.svg';
import { SetDutyType } from './DutyTimeModal/DutyTimeModal';
import { FormattedDutyType } from '@/utils/time';
import theme from '@/styles/theme';

interface Props {
  dutyTime: FormattedDutyType;
  onChangeSelect: (data: SetDutyType) => void;
  onClickHoliday: (weekDay: number) => void;
}

const TimeSelectItem = (props: Props) => {
  const { dutyTime, onChangeSelect, onClickHoliday } = props;
  const isClosed = dutyTime.isClosed;

  const getMinuteOption = (time: number) => {
    return minutes.filter(minute => minute.value === time);
  };

  const selectStyle = {
    width: '145px'
  };

  return (
    <Wrapper>
      <FlexRow>
        <OpenTimeSelect>
          <DayText colorValue={dutyTime.weekDay}>{dutyTime.day}</DayText>
          <SelectComponent
            options={hours}
            defaultValue={hours[dutyTime.openHour]}
            disabled={isClosed}
            onChange={e =>
              onChangeSelect({
                weekDay: dutyTime.weekDay,
                type: 'openHour',
                value: e
              })
            }
            selectStyle={selectStyle}
          />
          <SelectComponent
            options={minutes}
            defaultValue={getMinuteOption(dutyTime.openMinute)}
            disabled={isClosed}
            onChange={e =>
              onChangeSelect({
                weekDay: dutyTime.weekDay,
                type: 'openMinute',
                value: e
              })
            }
            selectStyle={selectStyle}
          />
        </OpenTimeSelect>
        <CloseTimeSelect>
          <SelectComponent
            options={hours}
            defaultValue={hours[dutyTime.closeHour]}
            disabled={isClosed}
            onChange={e =>
              onChangeSelect({
                weekDay: dutyTime.weekDay,
                type: 'closeHour',
                value: e
              })
            }
            selectStyle={selectStyle}
          />
          <SelectComponent
            options={minutes}
            defaultValue={getMinuteOption(dutyTime.closeMinute)}
            disabled={isClosed}
            onChange={e =>
              onChangeSelect({
                weekDay: dutyTime.weekDay,
                type: 'closeMinute',
                value: e
              })
            }
            selectStyle={selectStyle}
          />
          <HolidayCheck onClick={() => onClickHoliday(dutyTime.weekDay)}>
            {isClosed ? <Checked /> : <UnChecked />}{' '}
            <TextComponent fontWeight={600}>휴무일</TextComponent>
          </HolidayCheck>
        </CloseTimeSelect>
      </FlexRow>
    </Wrapper>
  );
};

export default TimeSelectItem;

const Wrapper = styled.div`
  margin-bottom: 20px;
`;

const FlexRow = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
`;

const OpenTimeSelect = styled(FlexRow)`
  margin-right: 30px;
  > * {
    &:nth-child(2) {
      margin-right: 10px;
    }
  }
`;
const CloseTimeSelect = styled(FlexRow)`
  > * {
    &:nth-child(1) {
      margin-right: 10px;
    }
  }
`;

const HolidayCheck = styled(FlexRow)`
  margin-bottom: 3px;
  width: 100px;
  align-items: flex-end;
  justify-content: flex-end;
  cursor: pointer;
`;

const DayText = styled(TextComponent)<{ colorValue: number }>`
  font-size: 20px;
  font-weight: 600;
  width: 75px;
  color: ${({ colorValue }) =>
    colorValue > 6 ? '#FF3030' : colorValue === 6 ? theme.DF_COLOR.BLUE600 : theme.DF_COLOR.BLACK};
`;
